import React from 'react'

const Security = () => {
  return (
    <div>
    <section className="hero"><br /><br /><br /><br /><br /><br /><br />
    <div className='hero-content'>
        <h1>Cyber Security in IT Technologies</h1>
        <p>Protecting data, networks, and systems from cyber threats</p>
        </div>
    </section>

    <section className="section-cyber">
        <h2>IT Technologies in Cyber Security</h2>

        <div className="cyber-cards">
            <div className="type-card">
                <h3>Network Security</h3>
                <p>Protects networks from unauthorized access, attacks, and data breaches using firewalls and monitoring tools.</p>
            </div>

            <div className="type-card">
                <h3>Cloud Security</h3>
                <p>Ensures data protection and privacy in cloud environments using encryption and access control.</p>
            </div>

            <div className="type-card">
                <h3>Application Security</h3>
                <p>Focuses on securing software applications from vulnerabilities and cyber attacks.</p>
            </div>

            <div className="type-card">
                <h3>AI in Cyber Security</h3>
                <p>Uses artificial intelligence to detect threats, malware, and suspicious activities automatically.</p>
            </div>

            <div className="type-card">
                <h3>Ethical Hacking</h3>
                <p>Authorized testing of systems to identify and fix security weaknesses.</p>
            </div>

            <div className="type-card">
                <h3>Data Encryption</h3>
                <p>Protects sensitive information by converting data into unreadable formats.</p>
            </div>
        </div>
    </section>
    <footer className="security-footer">
        <p>© 2026 Cyber Security | IT Technologies</p>
    </footer>
    <img src="./Amivel/grp1.jpg" alt="hii"  />
    </div>
  )
}

export default Security